export default "__VITE_ASSET__B5g886aI__"